"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintCta = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const PrintCta = ({
  className,
  href,
  ...props
}) => href && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
  maxWidth: _constants.CTA_MAX_WIDTH,
  variant: "button",
  className: className,
  href: href,
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
    id: "print"
  })
});
exports.PrintCta = PrintCta;
